module.exports = __webpack_public_path__ + "static/media/pig eon 5.1ade8aeb.png";